module.exports = __webpack_public_path__ + "static/media/discover_icon.2f844363.svg";